import { render, staticRenderFns } from "./evaluationScore.vue?vue&type=template&id=ed50ab08&scoped=true&"
import script from "./evaluationScore.vue?vue&type=script&lang=js&"
export * from "./evaluationScore.vue?vue&type=script&lang=js&"
import style0 from "./evaluationScore.vue?vue&type=style&index=0&id=ed50ab08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed50ab08",
  null
  
)

export default component.exports